import * as d3 from 'd3';
import { GroupHistogramData, OriginalDataItem } from '../../../types/histogram.types';
import { createDefaultCategoricalScale } from '../../constants/palette-utils';

interface HistogramLegendProps {
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  groupHistData: GroupHistogramData[];
  selectedIndices: number[];
  actualWidth: number;
  marginRight: number;
  marginTop: number;
  groupMode: 'overlay' | 'stacked' | 'faceted';
}

/**
 * ヒストグラムの凡例を描画する関数
 */
export const renderHistogramLegend = ({
  svg,
  groupHistData,
  selectedIndices,
  actualWidth,
  marginRight,
  marginTop,
  groupMode
}: HistogramLegendProps): void => {
  // 既存の凡例を削除
  svg.selectAll('.legend').remove();

  const colorScale = createDefaultCategoricalScale();

  const legend = svg.append('g')
    .attr('class', 'legend')
    .attr('transform', `translate(${actualWidth - marginRight + 10}, ${marginTop + 10})`);

  groupHistData.forEach((group, i) => {
    const legendItem = legend.append('g')
      .attr('transform', `translate(0, ${i * 20})`);

    // 選択データの数を計算
    const selectedCount = selectedIndices && selectedIndices.length > 0
      ? group.originalData.filter((item: OriginalDataItem) => selectedIndices.includes(item.index)).length
      : 0;
    const hasSelection = selectedCount > 0;

    legendItem.append('rect')
      .attr('width', 15)
      .attr('height', 15)
      .attr('fill', colorScale(group.groupName))
      .style('opacity', groupMode === 'overlay' ? 0.6 : 0.8)
      .style('stroke', hasSelection ? '#ff6b6b' : 'none')
      .style('stroke-width', hasSelection ? 2 : 0);

    legendItem.append('text')
      .attr('x', 20)
      .attr('y', 12)
      .style('font-size', '12px')
      .style('font-weight', hasSelection ? 'bold' : 'normal')
      .text(group.groupName + (hasSelection ? ` (${selectedCount})` : ''));
  });
};
